<!-- <app-header (isShowSidebar)="sidenav.toggle($event)" [isMenuOpened]="isShowSidebar"></app-header> -->
<div class="example-container">
  <!-- Chirstmas Lights -->
  <!-- <ul *ngIf="this.environmentService?.env?.customTheme === 'christmasTheme'" class="lightrope primaryColorBG">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul> -->
  
  <button class="skip-link" type="button" (click)="skipToMainContent()">
    {{ 'Accessibility-SkipToMainContent' | translate: {Default: "Skip to main content"} }}
  </button>

  <app-navigation></app-navigation>

  <main class="layout-content" id="main-content" tabindex="-1">
    <ng-content></ng-content>
  </main>
</div>

